/* JBL Flow Fest 2026 | Carrusel hero, "Ver los N productos", chip de la categoría visible
   y desfase de la barra de categorías bajo el header fijo del tema.
   Cada sección jblff-* carga este archivo; la guarda evita que se ejecute dos veces. */
(function () {
  if (window.JBLFF) return;
  window.JBLFF = { version: 1 };

  var reduce = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };

  /* ───── Carrusel hero (data-jblff-hero) ───── */
  function initHero(root) {
    if (root.dataset.jblffReady) return;
    root.dataset.jblffReady = '1';
    var track = root.querySelector('.ffhero__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.ffhero__slide'));
    var n = slides.length, i = 0, timer = null, paused = false;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var live = root.querySelector('.ffhero__live');
    var dotsWrap = root.querySelector('.ffhero__dots');
    var dots = [];

    function play(el) { if (!el) return; el.classList.remove('is-play'); void el.offsetWidth; el.classList.add('is-play'); }
    if (n < 2) {
      slides.forEach(function (s) { play(s.querySelector('.ff--hero')); });
      root.querySelectorAll('.ffhero__btn,.ffhero__dots,.ffhero__pause').forEach(function (e) { e.hidden = true; });
      return;
    }

    slides.forEach(function (s, k) {
      s.setAttribute('role', 'group'); s.setAttribute('aria-roledescription', 'slide');
      s.setAttribute('aria-label', (k + 1) + ' de ' + n);
      var d = document.createElement('button');
      d.className = 'ffhero__dot'; d.type = 'button';
      d.setAttribute('aria-label', 'Ir al banner ' + (k + 1));
      d.addEventListener('click', function () { go(k, true); });
      dotsWrap.appendChild(d); dots.push(d);
    });

    function go(k, user) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      slides.forEach(function (s, j) {
        s.setAttribute('aria-hidden', j === i ? 'false' : 'true');
        s.querySelectorAll('a,button').forEach(function (e) { e.tabIndex = j === i ? 0 : -1; });
        if (s.tagName === 'A') s.tabIndex = j === i ? 0 : -1;
        var f = s.querySelector('.ff--hero');
        if (f) { if (j === i) play(f); else f.classList.remove('is-play'); }
      });
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (live && user) live.textContent = 'Banner ' + (i + 1) + ' de ' + n;
      restart();
    }
    function stop() { clearInterval(timer); timer = null; }
    function restart() { stop(); if (!paused && !reduce()) timer = setInterval(function () { go(i + 1); }, interval); }

    var prev = root.querySelector('.ffhero__prev'), next = root.querySelector('.ffhero__next');
    if (prev) prev.addEventListener('click', function () { go(i - 1, true); });
    if (next) next.addEventListener('click', function () { go(i + 1, true); });

    var pb = root.querySelector('.ffhero__pause');
    if (pb) {
      if (reduce()) { paused = true; pb.textContent = 'Reanudar'; pb.setAttribute('aria-pressed', 'true'); }
      pb.addEventListener('click', function () {
        paused = !paused; pb.textContent = paused ? 'Reanudar' : 'Pausar';
        pb.setAttribute('aria-pressed', paused ? 'true' : 'false'); restart();
      });
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', restart);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', restart);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : restart(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(i - 1, true);
      if (e.key === 'ArrowRight') go(i + 1, true);
    });

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 !== null) { var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1), true); else restart(); }
      x0 = null;
    });

    go(0);
  }

  /* ───── Categorías: "Ver los N productos" y chip de la sección visible ───── */
  function initCats(root) {
    if (root.dataset.jblffReady) return;
    root.dataset.jblffReady = '1';
    var show = parseInt(root.getAttribute('data-show'), 10) || 8;
    root.querySelectorAll('.more__btn').forEach(function (mb) {
      var s = mb.closest('.cat');
      mb.addEventListener('click', function () {
        var open = mb.getAttribute('aria-expanded') === 'true';
        s.querySelectorAll('.card').forEach(function (cd, k) { if (k >= show) cd.hidden = open; });
        mb.setAttribute('aria-expanded', open ? 'false' : 'true');
        mb.textContent = open ? 'Ver los ' + mb.dataset.n + ' productos' : 'Ver menos';
      });
    });
    if (!('IntersectionObserver' in window)) return;
    var chips = root.querySelectorAll('.chip:not(.chip--all)');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) chips.forEach(function (ch) { ch.classList.toggle('on', ch.getAttribute('href') === '#' + e.target.id); });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    root.querySelectorAll('.cat').forEach(function (s) { io.observe(s); });
  }

  /* ───── Header fijo del tema: la barra de categorías se pega justo debajo ─────
     El plugin sticky del tema deja el wrapper en su lugar y fija (position:fixed) al hijo. Solo se mide el header:
     el wrapper de escritorio también trae los paneles del mega menú, fijos y ocultos. */
  var HEADERS = '.header-sticky-wrapper.is-sticky > #header, .header-sticky-wrapper.is-sticky > #mobile-header, .announcement-sticky-wrapper.is-sticky > *';
  var lastTop = -1;
  function stickyTop() {
    var top = 0;
    document.querySelectorAll(HEADERS).forEach(function (h) {
      var cs = getComputedStyle(h);
      if (cs.position !== 'fixed' || cs.visibility === 'hidden') return;
      var r = h.getBoundingClientRect();
      if (r.height && r.bottom > top && r.bottom < window.innerHeight / 2) top = r.bottom;
    });
    top = Math.round(top);
    if (top !== lastTop) { lastTop = top; document.documentElement.style.setProperty('--jblff-top', top + 'px'); }
  }

  function init(scope) {
    scope.querySelectorAll('[data-jblff-hero]').forEach(initHero);
    scope.querySelectorAll('[data-jblff-cats]').forEach(initCats);
  }
  function start() {
    init(document);
    if (document.querySelector('.jblff-lp .cats')) {
      stickyTop();
      window.addEventListener('scroll', stickyTop, { passive: true });
      window.addEventListener('resize', stickyTop);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
